<template>
  <div class="meal-container">
    <div class="meal-header">
      <EditableCellInput 
        v-model="meal.name" 
        class="meal-title" 
        :state="$v.meal.name.$invalid ? false : null "
      />
      <div class="meal-btnbar">
        <div class="meal-btnbar-group">
          <b-button class="remove-btn" @click="$emit('remove', index)">
            <IconCross alt="Eliminar comida" />
          </b-button>
        </div>
        <div class="meal-btnbar-group">
          <EditableCellInput 
            inputType="time" 
            v-model="meal.start_time" 
            class="meal-time"
            :state="$v.meal.start_time.$invalid ? false : null "
          />
          -
          <EditableCellInput 
            inputType="time" 
            v-model="meal.end_time" 
            class="meal-time"
            :state="$v.meal.end_time.$invalid ? false : null "
          />
        </div>
      </div>
    </div>

    <transition name="table-transition">
      <div class="meal-table-wrapper" v-if="meal.portions">
        <MealPortionsTable v-model="meal.portions" />
      </div>
    </transition>

    <div class="example-wrapper" v-if="meal.examples">
      <ProgramIndications
        v-model="meal.examples"
        :presets="examplePresets"
        :title="'Ejemplos'"
        :title-size="'sm'"
        class="example-container"
      />
    </div>
  </div>
</template>

<script>
import EditableCellInput from "../EditableCellInput";
import MealPortionsTable from "../table/MealPortionsTable";
import ProgramIndications from "../ProgramIndications"
import IconCross from "../icon/IconCross";
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: "PlanMeal",
  components: {
    IconCross,
    MealPortionsTable,
    ProgramIndications,
    EditableCellInput
  },
  model: {
    prop: "mealData",
    event: "change"
  },
  props: {
    index: Number,
    mealData: {
      type: Object,
      default: function() {
        return {
          name: null,
          start_time: null,
          end_time: null
        };
      }
    },
    examplePresets: {
      type: Array,
      default: function () { return [{ name: "Vacio" , text: ""}] },
    }
  },
  data: function() {
    return {
      meal: this.mealData,
      savedRoutine: {},
      defaultRoutine: {
        exercises: [],
        cardio_start: {},
        cardio_end: {}
      }
    };
  },
  validations: {
    meal: {
      name: {
        maxLength: maxLength(150)
      },
      start_time: {
        isTime (value) {
          let isNull = value === undefined || value === null || value === ""
          return isNull
            || this.$moment(value, "HH:mm:ss", true).isValid()
            || this.$moment(value, "HH:mm", true).isValid()
        }
      },
      end_time: {
        isTime (value) {
          let isNull = value === undefined || value === null || value === ""
          return isNull
            || this.$moment(value, "HH:mm:ss", true).isValid()
            || this.$moment(value, "HH:mm", true).isValid()
        }
      }
    }
  },
  watch: {
    "meal.start_time": {
      deep: true,
      handler: function (newVal, oldVal) {
        if(newVal !== oldVal) {
          this.$emit("changed-time")
        }
      }
    },
    meal: function(val) {
      this.$emit("change", val)
    }
  },
  mounted() {
    // pass
  },
  methods: {
    // pass
  }
};
</script>

<style scoped lang="scss">
.meal-container {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid $gray-500;
  border-radius: 10px;
  padding: 0 map_get($spacers, 4);
  margin: $spacer * 3 0;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.meal-header {
  position: sticky;
  display: flex;
  align-items: center;
  text-align: center;
  width: 100%;
  top: 0;
  background-color: white;
  z-index: $zindex-sticky;
  padding: map_get($spacers, 2) 0;
  border-bottom: 1px solid $gray-300;
}

.meal-title {
  margin-right: 15rem;
  margin-left: 3rem;
  font-size: $h3-font-size;
  font-weight: bold;
  color: $body-color;
  width: 100%;
  height: auto;
  text-align: left;
}

.meal-time {
  font-size: $h5-font-size;
  color: $body-color;
  border: 1px solid $gray-400;
  border-radius: 5px;
}

.example-wrapper {
  display: flex;
  width: 100%;
  justify-content: center;

}
.example-container {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid $gray-400;
  border-radius: 10px;
  width: 85%;
  padding: 0 map_get($spacers, 4) map_get($spacers, 2);
  margin: 0 $spacer $spacer $spacer;
}

.meal-btnbar {
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: -1;

  & .meal-btnbar-group input {
    margin: 0 map_get($spacers, 1);
    padding: 0.5rem;
    line-height: 1;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    & svg {
      width: 100%;
      height: 100%;
      fill: currentColor;
    }
  }

  & .remove-btn {
    background-color: transparent;
    border: none;
    color: $gray-600;
    opacity: 0.2;

    .meal-header:hover & {
      opacity: 0.5;
    }

    &:hover {
      opacity: 1 !important;
    }
  }
}

.meal-btnbar-group {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.meal-table-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: $spacer;
  margin-bottom: $spacer;
  text-align: center;
  align-items: center;
  width: 100%;
}

.table-transition-enter-active,
.table-transition-leave-active {
  transition-property: margin, opacity, max-height;
  transition-duration: 0.25s;
}

.table-transition-enter,
.table-transition-leave-to {
  margin-top: 0;
  margin-bottom: 0;
  opacity: 0;
  max-height: 0;
}

.table-transition-leave,
.table-transition-enter-to {
  opacity: 1;
  max-height: 10rem;
}
</style>